import { cx } from './classNames';
import styles from './Skeleton.module.css';

export interface SkeletonProps {
  variant?: 'line' | 'card' | 'avatar' | 'image';
  size?: 'sm' | 'md' | 'lg';
  length?: 'short' | 'medium' | 'long';
  card?: 'compact' | 'tall';
  image?: 'square' | 'portrait';
  className?: string;
}

export interface SkeletonGridProps {
  count?: number;
  card?: 'compact' | 'tall';
  className?: string;
}

export function Skeleton({
  variant = 'line',
  size = 'md',
  length,
  card,
  image,
  className,
}: SkeletonProps) {
  return (
    <span
      className={cx(
        styles.skeleton,
        styles[variant],
        variant === 'line' && size === 'sm' && styles.lineSm,
        variant === 'line' && size === 'lg' && styles.lineLg,
        variant === 'line' && length && styles[length],
        variant === 'card' && card && styles[card],
        variant === 'avatar' && size === 'sm' && styles.avatarSm,
        variant === 'avatar' && size === 'lg' && styles.avatarLg,
        variant === 'image' && image && styles[image],
        className,
      )}
      aria-hidden="true"
    />
  );
}

export function SkeletonGrid({ count = 3, card = 'compact', className }: SkeletonGridProps) {
  return (
    <div className={cx(styles.grid, className)} aria-hidden="true">
      {Array.from({ length: count }, (_, index) => (
        <Skeleton key={index} variant="card" card={card} />
      ))}
    </div>
  );
}
